import { render, staticRenderFns } from "./FilesExport.vue?vue&type=template&id=b9158cd4&"
import script from "./FilesExport.vue?vue&type=script&lang=ts&"
export * from "./FilesExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports